import {
    CREATE_PAYMENT_LINK,
    CREATE_PAYMENT_LINK_SUCCESS,
    CREATE_PAYMENT_LINK_FAIL,
    CHECK_PAYMENT_STATUS,
    CHECK_PAYMENT_STATUS_SUCCESS,
    CHECK_PAYMENT_STATUS_FAIL,
    GET_EXTERNAL_USERS_COUNT_SUCCESS,
    GET_EXTERNAL_USERS_COUNT,
    GET_EXTERNAL_USERS_COUNT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    payment_url: null,
    payment_status: null,
    loading: false,
    error: null,
    externalUsersCount: [],
};

const Subscriptions = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CREATE_PAYMENT_LINK:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_PAYMENT_LINK_SUCCESS:
            return {
                ...state,
                loading: false,
                payment_url: action.payload.payment_payload.payment_link_url,
            };
        case CREATE_PAYMENT_LINK_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CHECK_PAYMENT_STATUS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CHECK_PAYMENT_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                payment_status: action.payload.payment_status,
            };
        case CHECK_PAYMENT_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_EXTERNAL_USERS_COUNT:
            return {
                ...state,
                loading: true,
                error: null
            }
        case GET_EXTERNAL_USERS_COUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        case GET_EXTERNAL_USERS_COUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                externalUsersCount: action.payload.count,
                error: null
            }
        default:
            return state;
    }
};

export default Subscriptions;